import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=444139da&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&id=444139da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444139da",
  null
  
)

export default component.exports